import React from 'react';
import InfoOutlineIcon from '@material-ui/icons/InfoOutlined';
import { useTranslation } from 'react-i18next';
import { Typography } from '@thingsw/pitta-design-system';
import { LightColors } from '@thingsw/pitta-modules';

interface PublicCamInfoToastProps {
  setInfoOpen: (open: boolean) => void;
  infoOpen?: boolean;
}

export const PublicCamInfoToast = ({
  setInfoOpen,
  infoOpen,
}: PublicCamInfoToastProps) => {
  const { t } = useTranslation();

  return (
    <div
      style={{
        position: 'absolute',
        top: 32,
        left: 0,
        width: '100vw',
        padding: 24,
        zIndex: infoOpen ? 1000 : 0,
      }}
    >
      <div
        onClick={() => {
          setInfoOpen(false);
        }}
        style={{
          width: '100%',
          backgroundColor: LightColors.primary['9'],
          borderRadius: 8,
          padding: '8px 12px',
          boxShadow: '0 2px 6px rgba(0, 0, 0, 0.2)',
          display: 'flex',
          alignItems: 'center',
          gap: 4,
          transition: 'opacity 0.4s ease',
          opacity: infoOpen ? 1 : 0,
        }}
      >
        <InfoOutlineIcon />
        <Typography variant='Small' htmlColor={LightColors.primary['1']}>
          {t('Only cloud cameras_')}
        </Typography>
      </div>
    </div>
  );
};
